'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var TextParts = require('../common/TextParts');
var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper.js');
var _ = require('underscore');

var TextArea = React.createClass({

  render: function () {
    var w = styleHelper.getWidth(this.props);
    var showScrollBar = styleHelper.getBorderVisible(this.props) &&　this.props.verticalScrollbarShow;
    if(showScrollBar){
      w -= 16;
    }
    var textStyle = {
      width : w
    };

    return (<Border {...this.props}
        partStyle={{
          borderWidth: '1px',
          borderColor: this.props.borderColor ? styleHelper.getBorderColor(this.props) : '#000',
          zIndex: 0
        }}
      >

      {
        showScrollBar &&
        <VerticalScrollBar
          zIndex={1}
          value={parseInt(this.props.verticalScrollbarProgress)}/>
      }

      <TextParts ref="text" zIndex={0} {...this.props} partStyle={textStyle}/>
    </Border>);

  },

  componentDidMount : function(){
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize)
  },

  onResize : function(e){
    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
  }

});

module.exports = TextArea;



// WEBPACK FOOTER //
// ./src/views/Components/TextArea.jsx